export interface ILoginFields {
	identifier: string;
	autocomplete: 'username' | 'current-password';
	category: 'input' | 'select' | 'datepicker' | 'checkbox';
	type?: 'text' | 'password';
	label: string;
}

export const loginFields: ILoginFields[] = [
	{
		identifier: 'email',
		autocomplete: 'username',
		category: 'input',
		type: 'text',
		label: 'auth.fields.email',
	},
	{
		identifier: 'password',
		autocomplete: 'current-password',
		category: 'input',
		type: 'password',
		label: 'auth.fields.password',
	},
];

export interface LoginState {
	email: string;
	password: string;
}

export class LoginState {
	constructor(object?: LoginState) {
		this.email = object?.email || '';
		this.password = object?.password || '';
	}
}

export interface IUserToken {
	exp: number;
	iat: number;
	roles: string[];
	username: string;
}

export interface IProfileInfo {
	id: number;
	email: string;
	nickname: string;
	profile_picture?: string;
	allow_repeated_questions: boolean;
	display_name?: string;
	display_name_slug?: string;
	qpay_enabled?: boolean;
	role: 'ROLE_ADMIN' | 'ROLE_AUTHOR' | 'ROLE_USER';
	pool_exhaustion_warning?: boolean;
	used_voucher_codes?: string[];
}

export enum UserRole {
	ROLE_AUTHOR = 'ROLE_AUTHOR',
}
